import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedCountry } from 'contracts/Countries';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_COUNTRIES_',
  }
);

export interface ListCountriesState {
  data: ListedCountry[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListCountriesRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedCountry[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListCountriesState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListCountriesState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListCountriesState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListCountriesState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListCountriesState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listCountries = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListCountriesTypes = Types;
export const ListCountriesActions = Creators;
